import React from 'react'

export default function Mail() {
  return (
<svg  xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" >
  <path d="M36,45H14c-4.971,0-9-4.029-9-9V14c0-4.971,4.029-9,9-9h22c4.971,0,9,4.029,9,9v22C45,40.971,40.971,45,36,45z M11.07,17.49C11.02,17.65,11,17.82,11,18v14c0,0.18,0.02,0.35,0.07,0.51L18.59,25L11.07,17.49z M29.09,27.31 c-1.13,1.13-2.61,1.69-4.1,1.69c-1.48,0-2.97-0.56-4.1-1.69L20,26.41l-7.51,7.52C12.65,33.98,12.82,34,13,34h24 c0.18,0,0.35-0.02,0.51-0.07l-7.52-7.52L29.09,27.31z M27.68,25.89l9.83-9.82C37.35,16.02,37.18,16,37,16H13 c-0.18,0-0.35,0.02-0.51,0.07l9.82,9.82C23.79,27.37,26.2,27.37,27.68,25.89z M38.93,17.49L31.4,25l7.53,7.51 C38.98,32.35,39,32.18,39,32V18C39,17.82,38.98,17.65,38.93,17.49z"/></svg>
  )
}
